module.exports = __webpack_public_path__ + "static/BeVietnam-Bold-2cae2596ab54805883754b301b4fc5a3.woff2";